import { Box, Stack, Typography } from '@mui/material';
import { round } from 'lodash';
import { Fragment } from 'react';
import Icon from '/@/components/icon';
import { _ } from '/@/locale';
import type { ApplicationReport } from '/@/types/application-report';
import type { CropMonitoringNote } from '/@/types/crop-monitoring-note';
import { formatDate } from '/@/utils';
import { RegistryFooter } from './card-footer';
import { Cell, COLUMNS } from './data-grid';
import { RegistryCard } from './registry-card';
import RegistryNotes from './registry-notes';

/**
 * Read-only timeline card for a FieldView application report. Same layout as the manual
 * application card, but flagged with the FieldView icon and without edit/delete options.
 */
const RegistryApplicationReport = ({ report, notes }: { report: ApplicationReport; notes: CropMonitoringNote[] }) => {
    const first = report.results[0];
    if (!first) return null;

    return (
        <RegistryCard>
            <Stack direction='row' alignItems='center' spacing={0.5}>
                <Icon type='fieldview' style={{ fill: '#F7B618', width: '20px', height: '20px' }} />
                <Typography variant='h6' color='primary'>
                    {`${_('Aplicación de')} ${first.applicationName}`}
                </Typography>
            </Stack>

            <Box sx={{ display: 'grid', gridTemplateColumns: COLUMNS, width: '100%', overflow: 'auto' }}>
                <Cell header>{_('Fecha de aplicación')}</Cell>
                <Cell header>{_('Producto')}</Cell>
                <Cell header>{_('Dosis')}</Cell>
                {report.results.map((result) => (
                    <Fragment key={result.id}>
                        <Cell>{formatDate(new Date(result.eventStartDate))}</Cell>
                        <Cell>{result.chemicalProductName}</Cell>
                        <Cell>
                            {`${round(result.averageApplicationRate, 2)} ${result.applicationRateUnits}`.trim()}
                        </Cell>
                    </Fragment>
                ))}
            </Box>

            <RegistryNotes notes={notes} fieldId={report.field} applicationReportResultId={first.id} />

            <RegistryFooter authorName='FieldView' date={formatDate(new Date(report.created))} />
        </RegistryCard>
    );
};

export default RegistryApplicationReport;
